import React from 'react';
import {Table, Input, Checkbox, Button} from 'semantic-ui-react';

const FormParts = (props) => {
  const {principalPart, id, fr, description, quantity, price,
    priceTde, cost, fob, priceClaimProvider, handleChange, handleAddItem,
    handleCheckBox, handleKeyDown, loading} = props;
  const finalPrice = priceTde ? priceTde : priceClaimProvider;
  const validateBtn = description === '' || quantity <= 0;

  return (
    <Table.Row>
      <Table.Cell>
        <Checkbox
          disabled={loading}
          checked={principalPart === 'S'}
          onChange={handleCheckBox}
        />
      </Table.Cell>
      <Table.Cell>
        <Input
          disabled={loading}
          className='twc-part-input code-input'
          placeholder='No. de parte'
          value={id}
          type='text'
          onKeyDown={handleKeyDown}
          onChange={(e, {value}) => handleChange('id', value)}
        />
      </Table.Cell>
      <Table.Cell>{fr}</Table.Cell>
      <Table.Cell>{description}</Table.Cell>
      <Table.Cell>
        <Input
          className='twc-part-input'
          value={quantity}
          type='number'
          min='0'
          onChange={(e, {value}) => handleChange('quantity', value)}
        />
      </Table.Cell>
      <Table.Cell>$ {price ? price : 0}</Table.Cell>
      <Table.Cell>$ {price ? price : 0}</Table.Cell>
      <Table.Cell>
        <Input
          className='twc-part-input'
          placeholder='Precio TDE'
          value={finalPrice || 0}
          type='number'
          min='0'
          step='0.1'
          pattern='^\d+(?:\.\d{1,2})?$'
          onChange={(e, {value}) => handleChange('priceTde', value)}
        />
      </Table.Cell>
      <Table.Cell>
        {'$'}
        {cost.toFixed(2)}
      </Table.Cell>
      <Table.Cell>
        {'$'}
        {fob.toFixed(2)}
      </Table.Cell>
      <Table.Cell>
        <Input
          className='twc-part-input'
          placeholder='Precio Reclama a fábrica'
          value={priceClaimProvider}
          type='number'
          min='0'
          step='0.1'
          pattern='^\d+(?:\.\d{1,2})?$'
          onChange={(e, {value}) => handleChange('priceClaimProvider', value)}
        />
      </Table.Cell>
      <Table.Cell>
        {'$'}
        {(+quantity * +price).toFixed(2)}
      </Table.Cell>
      <Table.Cell>
        {'$'}
        {(+quantity * +priceTde).toFixed(2)}
      </Table.Cell>
      <Table.Cell>
        <Button
          disabled={validateBtn}
          onClick={() => handleAddItem()}
          size='mini'
          color='green'
        >
          Agregar
        </Button>
      </Table.Cell>
    </Table.Row>
  );
};

export default FormParts;
